import React, { useEffect, useState } from 'react'
import { MainContainer } from '../../../theme'

function ScatteredImage(props) {
  const array = [
    'start',
    'end',
    'start',
    'end',
    'end',
    'start',
    'end',
    'center',
    'end',
    'start',
    'end',
    'center',
  ]

  const {
    referenceIncorrectOption,
    referenceCorrectOption,
    onSelect,
    quesId,
    submit,
    finalAttempt,
  } = props
  const [correctAnswer, setCorrectAnswer] = useState()
  const [data, setData] = useState([])
  const [dataCopy, setDataCopy] = useState([])
  const [counter, setCounter] = useState(0)
  let otherData = []

  useEffect(() => {
    let data = []
    if (referenceCorrectOption && referenceIncorrectOption) {
      for (let i = 0; i < referenceCorrectOption.length; i++) {
        let correctObj = { answer: 'correct', url: referenceCorrectOption[i] }
        data.push(correctObj)
      }
      console.log('scatter', data)
      for (let i = 0; i < referenceIncorrectOption.length; i++) {
        let incorrectObj = { answer: 'wrong', url: referenceIncorrectOption[i] }
        data.push(incorrectObj)
      }
    }
    data = data.sort(() => Math.random() - 0.5)
    setData(data)
    otherData = JSON.parse(JSON.stringify(data))
    setCounter(0)
  }, [referenceCorrectOption, referenceIncorrectOption, submit])

  useEffect(() => {
    if (finalAttempt && referenceCorrectOption.length === counter) {
      let answerArray = data.map((data) => {
        let obj = {}
        if (data?.answer == 'correct') {
          return (obj = { ...data, right: true })
        } else {
          return (obj = { ...data })
        }
      })
      setDataCopy(answerArray)
    } else {
      setDataCopy(data)
    }
  }, [finalAttempt, data])

  const setQuestionData = (answer, index, url) => {
    console.log('answer', answer, index, url)
    onSelect(url, quesId, answer)
    setCounter(counter + 1)
    let scatterData = JSON.parse(JSON.stringify(data))
    if (answer === 'correct') {
      scatterData[index].right = true
    } else {
      scatterData[index].wrong = true
    }
    setData(scatterData)
  }

  return (
    <MainContainer
      bgcolor={'white'}
      className="mt-3 p-0"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
      }}
      height={'50vh'}
    >
      {/* {console.log('scatter',dataCopy,data)} */}
      {dataCopy?.map((data, index) => (
        <div
          className={`d-flex justify-content-${array[index]} align-items-${array[index]}`}
        >
          <img
            className={`m-1 ${
              data.right ? 'right' : data.wrong ? 'wrong' : ''
            }`}
            src={data.url}
            onClick={() =>
              !(referenceCorrectOption.length === counter) &&
              setQuestionData(data.answer, index, data.url)
            }
            style={{ height: '60px', borderRadius: '100%', padding: '5px' }}
          />
        </div>
      ))}
    </MainContainer>
  )
}

export default ScatteredImage
